<template>
  <div>
    <span class="caption">
      <b>{{ column.label }}</b>
    </span>
    <v-card width="100%" height="100%" color="#fafafa" @click="openFilePicker">
      <v-col class="fill-height" cols="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="fill-height"
          v-if="imgSrc == null"
        >
          <v-icon medium>mdi-attachment</v-icon>
          <v-row no-gutters justify="center">
            <span class="caption">Click here to change</span>
          </v-row>
        </v-row>
        <v-img v-else :src="imgSrc"></v-img>
      </v-col>

      <input
        type="file"
        @change="handleFilePicker"
        ref="filePicker"
        class="__filepicker-input"
      />
    </v-card>
    <!-- <v-row no-gutters>
      <v-col cols="8">
        <v-img v-if="imgSrc != null" :src="imgSrc"></v-img>
      </v-col>
    </v-row>
    <v-btn @click="openFilePicker" small color="primary">Select Image</v-btn> -->
  </div>
</template>

<script>
export default {
  props: {
    formData: Object,
    column: Object,
  },
  data() {
    return {
      imgSrc: null,
      selectedFile: null,
      controller: this.get_controller(this.column.controller),
    };
  },
  mounted() {},
  methods: {
    openFilePicker() {
      this.$refs.filePicker.click();
    },
    handleFilePicker(e) {
      let self = this;
      var file = e.target.files[0];

      if (file == null) {
        return;
      }

      console.log(this.formData, file);

      this.formData.media.name = file.name;
      this.formData.media.type = file.type;
      this.formData.file = file;

      const fr = new FileReader();

      fr.readAsDataURL(file);

      fr.onload = () => {
        self.imgSrc = fr.result;
      };
    },
  },
};
</script>

<style scoped>
.__filepicker-input {
  display: none;
  visibility: hidden;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}
</style>